import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Countdown, { zeroPad } from "react-countdown";
import { HiOutlineArrowSmallLeft } from "react-icons/hi2";
import { Alert, Button, Image, Typography } from "antd";
import { removeStorageWhenLogout, statusHtmlStorage } from "../../config/helper";
import { authResendVerify } from "../../store/auth/action";
import signUpIcon from "../../assets/img/image-signup.png";
import styles from "./signup.module.css";

class SignUpSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      alertState: {
        show: false,
        variant: "error",
        message: "",
      },
    };
    this.handleResendVerify = this.handleResendVerify.bind(this);
  }

  componentDidMount() {
    if (!statusHtmlStorage("signup-email")) {
      removeStorageWhenLogout();
      window.location.href = "/signin";
    }
  }

  handleResendVerify = async () => {
    await this.props.authResendVerify(`?email=${localStorage.getItem("signup-email")}`);

    this.setState({
      disabled: true,
      alertState: {
        show: true,
        variant: "success",
        message: `We have successfully sent a confirmation email to ${this.state.email}. Please check your inbox.`,
      },
    });
  };

  renderer = ({ hours, minutes, seconds }) => (
    <span>
      {zeroPad(minutes)}:{zeroPad(seconds)}
    </span>
  );

  render() {
    return (
      <div className={styles.auth_signup_page}>
        <div className={styles.auth_wrapper}>
          <Link to="/signin" className={styles.btn_back_login}>
            <HiOutlineArrowSmallLeft style={{ fontSize: 24 }} />
          </Link>
          <div className={styles.signup_success_wrapper}>
            <Image preview={false} src={signUpIcon} />
            <Typography.Title level={3}>
              Sign Up Verification Sent
            </Typography.Title>
            <Typography.Paragraph>
              We have sent a verification to your email. Please check you inbox
            </Typography.Paragraph>
          </div>
          <Typography.Text className={styles.auth_signup_account}>
            Didn't receive email?
            <Button
              type="primary"
              loading={this.props.loading}
              disabled={this.state.disabled}
              className={styles.btn_signup}
              onClick={this.handleResendVerify}
              style={{ marginTop: "0.5rem" }}
            >
              {this.state.disabled ? (
                <Countdown
                  date={Date.now() + 180000}
                  renderer={this.renderer}
                  onComplete={() => this.setState({ disabled: false })}
                />
              ) : (
                <>Re-send Verification Email</>
              )}
            </Button>
          </Typography.Text>
          {this.state.alertState.show && (
            <Alert
              closable
              type={this.state.alertState.variant}
              message={this.state.alertState.message}
              onClose={() =>
                this.setState({
                  alertState: {
                    show: false,
                    variant: "error",
                    message: "",
                  }
                })
              }
              style={{ marginTop: 10 }}
            />
          )}
        </div>
      </div>
    );
  }
}

const stateToProps = (state) => {
  const { auth } = state;
  return {
    loading: auth.loading,
    resendResponse: auth.resendResponse,
  };
};

const dispatchToProps = (dispatch) => ({
  authResendVerify: (params) => dispatch(authResendVerify(params)),
});

export default connect(stateToProps, dispatchToProps)(SignUpSuccess);
